import React from "react";
import Mountain from "../../Admin/Question/View/Background/Mountain";
import List from "./List";

class Quizzes extends React.Component {
    render() {
        return <List {...this.props} typeOfList="Quizzes" defaultIndexValue={8} Background={<Mountain />} Link="/Tracks/Quizzes/" typeOfLesson="Exams" Icon="fal fa-question" />;
    }
}
export default Quizzes;